import { useState } from 'react';
import { Alert, Box, Button, Snackbar, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import dayjs from 'dayjs';
import { useAuth } from '../../auth/AuthProvider';
import AgendaCalendar from './components/AgendaCalendar';
import AgendaList from './components/AgendaList';
import { AgendaSummary } from './components/AgendaPanels';
import CreateAppointmentDialog from './components/CreateAppointmentDialog';
import { agendaTimezone } from './agendaUtils';
import { useAgendaTranslation } from './translations';

export default function Agenda() {
    const { user, role } = useAuth();
    const { t } = useAgendaTranslation();
    const zone = agendaTimezone(user.timezone);
    const [range, setRange] = useState(() => {
        const today = dayjs().tz(zone).format('YYYY-MM-DD');
        return { start: today, end: today };
    });
    const [creating, setCreating] = useState(false);
    const [created, setCreated] = useState(false);
    return <Box sx={{ minWidth: 0, width: '100%' }}>
        <Stack component="header" direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between"
            spacing={2} sx={{ mb: 3 }}>
            <Box>
                <Typography variant="h4" color="primary.main">{role.account.name}</Typography>
                <Typography variant="caption" color="text.secondary">{t('Fuso horário')}: {zone}</Typography>
            </Box>
            <Button variant="contained" startIcon={<AddIcon />} onClick={() => setCreating(true)}
                sx={{ height: 46, minWidth: 205, borderRadius: 1.5, fontWeight: 700, textTransform: 'none' }}>
                {t('agenda.create')}
            </Button>
        </Stack>
        <Box sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'minmax(0, 2.1fr) minmax(300px, 1fr)' },
            gap: 2, alignItems: 'start'
        }}>
            <AgendaList clinic dateRange={range} roleUuid={role.uuid} clinicUuid={role.account.uuid} zone={zone} />
            <Box component="aside" sx={{ display: 'grid', gap: 2, minWidth: 0 }}>
                <AgendaCalendar initialRange={range} onApply={setRange} zone={zone} />
                <AgendaSummary clinic dateRange={range} roleUuid={role.uuid} clinicUuid={role.account.uuid} zone={zone} />
            </Box>
        </Box>
        {creating && <CreateAppointmentDialog roleUuid={role.uuid} clinicUuid={role.account.uuid}
            defaultDoctor={null} initialDate={range.start} zone={zone}
            onClose={() => setCreating(false)} onCreated={() => { setCreating(false); setCreated(true); }} />}
        <Snackbar open={created} autoHideDuration={6000} onClose={() => setCreated(false)}>
            <Alert severity="success" onClose={() => setCreated(false)}>{t('agenda.created')}</Alert>
        </Snackbar>
    </Box>;
}
